import React from "react";
import "../css/policy.css";

const UserDataDeletion = () => {
  return (
    <div className="data-deletion-container">
      
      <h1>User Data Deletion Policy</h1>
      <p>At H&H Fashion, we respect your privacy and your right to request deletion of your personal data.</p>
      <section>
        <h2>How to Request Data Deletion</h2>

        <p>To request deletion of your personal information, please follow the steps below:</p>

        <ol>
          <li>Send a WhatsApp message from your registered mobile number</li>
          <li>Type: <b>“DELETE MY DATA”</b></li>
          <li>
            Include the following details:
            <ul>
              <li>Full Name</li>
              <li>Registered Mobile Number</li>
              <li>Order ID (if available)</li>
            </ul>
          </li>
        </ol>
      </section>

      <section>
  <h2>Data That Will Be Deleted</h2>
  <p>Upon verification, we will delete:</p>
  <ul>
    <li>Name</li>
    <li>Mobile Number</li>
    <li>Delivery Address</li>
    <li>Chat history related to orders</li>
    <li>Any stored customer records</li>
  </ul>

  <h2>Data We May Retain</h2>
  <p>Certain information may be retained if required for:</p>
  <ul>
    <li>Legal or regulatory compliance</li>
    <li>Accounting and tax purposes</li>
    <li>Fraud prevention</li>
  </ul>
  <p><i>(Only the minimum required data will be retained.)</i></p>

  <h2>Processing Time</h2>
  <ul>
    <li>Data deletion requests are processed within <b>7–14 working days</b>.</li>
    <li>You will receive confirmation once the process is completed.</li>
  </ul>

  <h2>Important Notes</h2>
  <ul>
    <li>Data deletion may affect future order history and support.</li>
    <li>Deleted data cannot be recovered once removed.</li>
  </ul>
</section>

    </div>
  );
};

export default UserDataDeletion;
